// <template>
	// <link href="css/base.css" rel="stylesheet" />

	//
	<div>
		//
		<button class="btn btn-primary" @click="SendMail">Send Email</button> //
	</div>
	//
</template>

// <script>
// // const sgMail = require('@sendgrid/mail');

// export default {
// 	name: "MailTest",

// 	data() {
// 		return {};
// 	},
// 	methods: {
// 		SendMail() {
// 			// DoSendGridMail();
// 		},
// 	},
// };

// function DoSendGridMail() {
// 	// sgMail.setApiKey(process.env.SENDGRID_API_KEY);
// 	sgMail.setApiKey(
// 		"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"
// 	);

// 	const msg = {
// 		to: "test81@resonancemedia.ca",

// 		from: "website@onlineleader.ca",

// 		subject: "Example Email",

// 		text: `Dear user,    Here is your email.
//             `,

// 		html: `
//             <p>Dear user,</p>
//             <p>Here is your email.</p>
//             `,
// 	};

// 	sgMail.send(msg);
// }
//
</script>

